/* eslint-disable no-underscore-dangle */

import CryptoJS from 'crypto-js';
import {
  ALCATRAZ_CRYPTO_KEY,
  ALCATRAZ_CRYPTO_INITIAL_TOKEN,
  ALCATRAZ_STORAGE_KEYS,
  isAlcatrazCryptoActive,
} from './env';

/* eslint-disable no-console */
const LOG = (msg, ...args) => console.log('[AlcatrazCrypto]', msg, ...args);
/* eslint-enable no-console */

const isCryptoEnabled = () => isAlcatrazCryptoActive;

(function initLocalStorageEncryption() {
  LOG('init');
  if (typeof window === 'undefined' || typeof Storage === 'undefined') {
    LOG('bail: sem window ou Storage');
    return;
  }

  if (!ALCATRAZ_CRYPTO_KEY || !ALCATRAZ_STORAGE_KEYS?.has) {
    LOG('bail: ALCATRAZ_CRYPTO_KEY ou ALCATRAZ_STORAGE_KEYS vazio');
    return;
  }

  const token = (typeof ALCATRAZ_CRYPTO_INITIAL_TOKEN === 'string'
    ? ALCATRAZ_CRYPTO_INITIAL_TOKEN.trim()
    : '');
  if (!token) {
    LOG('bail: ALCATRAZ_CRYPTO_INITIAL_TOKEN vazio');
    return;
  }

  const storageKeys = ALCATRAZ_STORAGE_KEYS;
  const cryptoKey = String(ALCATRAZ_CRYPTO_KEY);
  LOG('ok', { encrypt: isAlcatrazCryptoActive, token, keys: [...storageKeys] });

  if (!Storage.prototype.__nativeGetItem) {
    Storage.prototype.__nativeGetItem = Storage.prototype.getItem;
  }
  if (!Storage.prototype.__nativeSetItem) {
    Storage.prototype.__nativeSetItem = Storage.prototype.setItem;
  }

  const nativeGetItem = Storage.prototype.__nativeGetItem;
  const nativeSetItem = Storage.prototype.__nativeSetItem;

  Storage.prototype.getItem = function getItem(key) {
    const storage = (this && typeof this.getItem === 'function') ? this : window?.localStorage;
    if (!storage) return null;
    let raw;
    try {
      raw = nativeGetItem.call(storage, key);
    } catch (error) {
      LOG('getItem error', key, error);
      return null;
    }
    if (raw == null) return null;
    const value = String(raw);
    if (!value.startsWith(token)) return value;
    try {
      const decrypted = CryptoJS.AES.decrypt(value.slice(token.length), cryptoKey);
      const utf8 = decrypted.toString(CryptoJS.enc.Utf8);
      const out = (utf8 && typeof utf8 === 'string') ? utf8 : null;
      LOG('getItem decrypt', key, out ? 'ok' : 'vazio ou falha');
      return out;
    } catch (error) {
      LOG('getItem decrypt error', key, error);
      return null;
    }
  };

  Storage.prototype.setItem = function setItem(key, value) {
    const storage = this ?? window?.localStorage;
    if (!storage) return;
    const val = value == null ? '' : String(value);
    if (isCryptoEnabled() && storageKeys.has(key)) {
      try {
        const encrypted = CryptoJS.AES.encrypt(val, cryptoKey).toString();
        nativeSetItem.call(storage, key, token + encrypted);
        LOG('setItem encrypt', key);
      } catch (error) {
        LOG('setItem encrypt error', key, error);
        nativeSetItem.call(storage, key, val);
      }
    } else {
      nativeSetItem.call(storage, key, val);
    }
  };

  if (window.localStorage) {
    window.localStorage.getItem = Storage.prototype.getItem;
    window.localStorage.setItem = Storage.prototype.setItem;
  }
  LOG('override aplicado');
}());
/* eslint-enable no-underscore-dangle */
